import { lazy } from 'react';
import { RouteObject } from 'react-router';
import { DocsDescriptor } from './components/views/Docs/doctypes';

import docsEnglish from '@/components/views/Docs/content/en/index.json';

const DocsGuardView = lazy(() => import('@/components/views/Docs/DocsGuardView'));
const DocsView = lazy(() => import('@/components/views/Docs/DocsView'));
const DocsContent = lazy(() => import('@/components/views/Docs/DocsContent'));

function generateChild(descriptor: DocsDescriptor, lang: 'en'): RouteObject {
  const route: RouteObject = {
    path: descriptor.slug,
    element: descriptor.content ? (
      <DocsContent lang={lang} markdownPath={descriptor.content} slug={descriptor.slug} key={descriptor.slug} />
    ) : undefined,
  };

  if (descriptor.children) {
    route.children = descriptor.children
      .filter((dd) => import.meta.env.DEV || !dd.devOnly)
      .map((dd) => generateChild(dd, lang));
  }

  return route;
}

export const docRoutes: RouteObject = {
  path: '/documentation',
  Component: DocsGuardView,
  children: [
    {
      path: 'en',
      Component: DocsView,
      children: [generateChild(docsEnglish satisfies DocsDescriptor, 'en')],
    },
    // Add new languages here to generate paths for their docs
  ],
};
